import dayjs from 'dayjs';
import {ScheduleCalendarType} from '../types';
import {getPeriodWithPadding} from './getPeriodWithPadding';

export const getStepsWithPadding = (
  date: Date | string,
  calendarType: ScheduleCalendarType,
): Date[] => {
  const period = getPeriodWithPadding(date, calendarType);
  const fromDateTime = dayjs(period.fromDateTime);
  const toDateTime = dayjs(period.toDateTime);
  const diffType = calendarType === 'day' ? 'hour' : 'day';
  const diff = toDateTime.diff(fromDateTime, diffType) + 1; // Add 1 to get ~to-date/time inclusive
  return Array.from(Array(diff).keys()).map((_, index) =>
    fromDateTime.add(index, diffType).toDate(),
  );
};
